interface Props {
  current: number;
  longest: number;
}

// Minimal SVG streak ring: a circle with an arc indicating progress towards
// the longest streak. Visual polish can come later — SPEC-016 just requires
// the ring to be present and reflect the current vs longest values.
export function StreakRing({ current, longest }: Props) {
  const size = 120;
  const stroke = 10;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = longest > 0 ? Math.min(current / longest, 1) : 0;
  const offset = circumference * (1 - ratio);

  return (
    <div className="flex flex-col items-center gap-2">
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--color-separator)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--color-accent)"
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text
          x={size / 2}
          y={size / 2 + 6}
          textAnchor="middle"
          fontSize="28"
          fontWeight="600"
          fill="var(--color-fg)"
        >
          {current}
        </text>
      </svg>
      <div className="text-xs text-[var(--color-muted)]">
        Longest: <span className="font-medium text-[var(--color-fg)]">{longest}</span>
      </div>
    </div>
  );
}
